export default {"src":"/_next/static/media/0x8b9734bbaa628bfc0c9f323ba08ed184e5b88da2.13c0645d.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};